import { PageId } from '../../features/PlatformEvents';
import { LazyTeamRoute } from '../../features/Team';
import { LazyArtistFooter, LazyArtistMain, LazyArtistHeader } from '../Artist';
import { LazyTeamHeader } from '../../features/TeamHeader';
import { LazyUserSettingsHeader } from '../../features/UserSettingsHeader';
import { PageRouteProps } from './PageRoute';
import {
  RequestAccessRoute,
  InviteRoute,
  AddArtistRoute,
  SettingsRoute,
  ContentMismatchRoute,
  RootRoute,
} from './lazy';
import {
  LazyHypeRoute,
  LazyHypeHeader,
  LazyHypeFooter,
} from '../../features/Hype';
import { ActivityRoute } from '../../features/Activity';
import { LazyRosterHeader, LazyRosterRoute } from '../../features/Roster';
import { LazyNewMusicSubmission } from '../../features/NewMusicSubmission';
import { FundraisingRoute } from '../../features/ArtistProfile/Fundraising';
import { ArtistFallback } from '../../shared/components/ArtistFallback';

// TODO some of these urls need to switch to pathname routing before this can work properly
// c/add-artist
// c/add-artist?&step=confirm
// c/add-artist?&step=search
// c/artist/:artistId/profile
// c/artist/:artistId/profile
// c/artist/:artistId/profile#about
// c/artist/:artistId/profile#concerts
// c/artist/:artistId/profile#overview
// c/artist/:artistId/profile/edit-image
// c/content-missmatch

const defaultArtistProps = {
  header: LazyArtistHeader,
  body: LazyArtistMain,
  footer: LazyArtistFooter,
};

const defaultSettingsProps = {
  header: LazyUserSettingsHeader,
  body: SettingsRoute,
  footer: LazyArtistFooter,
};

const defaultTeamProps = {
  header: LazyTeamHeader,
  body: LazyTeamRoute,
  footer: LazyArtistFooter,
};

const defaultHypeProps = {
  header: LazyHypeHeader,
  body: LazyHypeRoute,
  footer: LazyHypeFooter,
};

export const routeConfig: PageRouteProps[] = [];

// STATIC ROUTES

addRoute({
  ...defaultArtistProps,
  path: '/artist/:artistId',
  body: ArtistFallback,
  exact: true,
});

addRoute({
  pageId: PageId.AddArtistSearch,
  path: '/add-artist/search',
  body: AddArtistRoute,
  exact: true,
});

addRoute({
  pageId: PageId.AddArtistConfirm,
  path: '/add-artist/confirm',
  body: AddArtistRoute,
  exact: true,
});

addRoute({
  pageId: PageId.ArtistProfileFundraising,
  path: '/artist/:artistId/profile/fundraising',
  body: FundraisingRoute,
  showHelp: false,
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistProfile,
  path: '/artist/:artistId/profile/overview',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistProfileAbout,
  path: '/artist/:artistId/profile/about',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistProfileConcerts,
  path: '/artist/:artistId/profile/concerts',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistProfileImagesEdit,
  path: '/artist/:artistId/profile/edit-image',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistAudience,
  path: '/artist/:artistId/audience',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistHome,
  path: '/artist/:artistId/home',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistLabs,
  path: '/artist/:artistId/labs',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistLabsArtistHistory,
  path: '/artist/:artistId/labs/artist-history',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistMusic,
  path: '/artist/:artistId/music',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistCampaigns,
  path: '/artist/:artistId/campaigns',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistCampaignAdmin,
  path: '/artist/:artistId/campaign-admin',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistPlaylists,
  path: '/artist/:artistId/music/playlists',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistReleases,
  path: '/artist/:artistId/music/releases',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistSongs,
  path: '/artist/:artistId/music/songs',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistUpcoming,
  path: '/artist/:artistId/music/upcoming',
  exact: true,
});

addRoute({
  body: LazyNewMusicSubmission,
  pageId: PageId.ArtistNMS,
  path: '/artist/:artistId/submission/:albumId/view',
  exact: true,
});

addRoute({
  body: LazyNewMusicSubmission,
  pageId: PageId.ArtistNMSCreate,
  path: '/artist/:artistId/submission/:albumId/create',
  exact: true,
});

addRoute({
  body: LazyNewMusicSubmission,
  pageId: PageId.ArtistNMSEdit,
  path: '/artist/:artistId/submission/:albumId/edit',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistSongPlaylists,
  path: '/artist/:artistId/song/:songId/playlists',
  exact: true,
});

addRoute({
  ...defaultArtistProps,
  pageId: PageId.ArtistSongStats,
  path: '/artist/:artistId/song/:songId/stats',
  exact: true,
});

addRoute({
  ...defaultHypeProps,
  path: '/hype',
  exact: true,
});

addRoute({
  ...defaultHypeProps,
  header: undefined,
  footer: undefined,
  path: '/hype/create',
  exact: true,
});

addRoute({
  ...defaultHypeProps,
  path: '/hype/campaign/:campaignId',
  exact: true,
});

addRoute({
  ...defaultHypeProps,
  header: undefined,
  footer: undefined,
  path: '/hype/campaign/:campaignId/edit',
  exact: true,
});

addRoute({
  pageId: PageId.TeamManagementAcceptInvite,
  path: '/team/accept-invite/:inviteId',
  body: LazyTeamRoute,
  exact: true,
});

addRoute({
  ...defaultTeamProps,
  pageId: PageId.TeamManagement,
  path: '/team/artist/:artistId',
  exact: true,
});

addRoute({
  ...defaultTeamProps,
  pageId: PageId.TeamManagementDetails,
  path: '/team/artist/:artistId/details',
  exact: true,
});

addRoute({
  ...defaultTeamProps,
  pageId: PageId.TeamManagementInvite,
  path: '/team/artist/:artistId/invite',
  exact: true,
});

addRoute({
  ...defaultTeamProps,
  pageId: PageId.TeamLabelArtists,
  path: '/team/label/:labelId/artists',
  exact: true,
});

addRoute({
  pageId: PageId.ArtistDistributorInvite,
  path: '/distributor/invite/:token',
  body: InviteRoute,
  exact: true,
});

addRoute({
  header: LazyRosterHeader,
  body: LazyRosterRoute,
  footer: LazyArtistFooter,
  pageId: PageId.Roster,
  path: '/roster',
  exact: true,
});

addRoute({
  ...defaultSettingsProps,
  pageId: PageId.UserSettings,
  path: '/settings',
  exact: true,
});

addRoute({
  pageId: PageId.ArtistContentMismatch,
  path: '/content-mismatch',
  body: ContentMismatchRoute,
  exact: true,
});

addRoute({
  path: '/',
  body: RootRoute,
  exact: true,
});

addRoute({
  path: '/team/label/join',
  body: LazyTeamRoute,
  exact: true,
});

// LEGACY DYNAMIC ROUTES

addRoute({
  path: '/access',
  body: RequestAccessRoute,
});

addRoute({
  path: '/get-access',
  body: RequestAccessRoute,
});

addRoute({
  ...defaultArtistProps,
  path: '/artist/:artistId',
});

addRoute({
  ...defaultTeamProps,
  path: '/team',
});

addRoute({
  path: '/activity',
  header: LazyTeamHeader,
  body: ActivityRoute,
});

addRoute({
  path: '/invite/:token',
  body: InviteRoute,
});

addRoute({
  path: '/distributor/invite/:token',
  body: InviteRoute,
});

addRoute({
  path: '/add-artist',
  body: AddArtistRoute,
});

addRoute({
  ...defaultSettingsProps,
  path: '/settings',
});

addRoute({
  path: '/content-mismatch',
  body: ContentMismatchRoute,
});

// HELPERS

function addRoute(route: PageRouteProps) {
  routeConfig.push(route);
}
